export const coberturasAuto = '/cotacao/auto/coberturas/:idIntegracao';
export const configuracoes = '/configuracoes';
export const configCorretora = '/config-corretora';
export const configUsuarios = '/config-usuarios';
export const configSeguradoras = '/config-seguradoras';
export const configRamos = '/config-ramos';
export const configCoberturas = '/config-coberturas';
export const configPreferencias = '/config-preferencias';
export const corretorDigital = '/corretor-digital';
export const cotacoes = '/cotacoes';
export const enviarCalculo = '/cotacao/:ramo/enviarCalculo/:idIntegracao';
export const faturasNFe = '/faturas-nfe';
export const formulario = '/cotacao/:ramo/formulario/:idIntegracao';
export const formularioNovo = '/cotacao/:ramo/formulario';
export const orcamento = '/orcamento?id=:id&ramo=:ramo';
export const resultados = '/cotacao/:ramo/resultados/:idIntegracao';
export const resultadosAdmin = '/cotacao/:ramo/resultados/:idIntegracao/:versao/:token';
export const simuladorDeComissoes = '/cotacao/:ramo/simuladorComissoes/:idIntegracao';
export const ajustePorSeguradora = '/cotacao/:ramo/ajustePorSeguradora/:idIntegracao';
export const contratacao = '/contratar';

export const routeMapper = [
    { path: ajustePorSeguradora, label: 'Ajustes Por Seguradora', breadcrumb: [cotacoes, resultados, formulario, enviarCalculo, coberturasAuto] },
    { path: coberturasAuto, label: 'Coberturas', breadcrumb: [cotacoes, resultados, formulario, enviarCalculo] },
    { path: configuracoes, label: 'Configurações', breadcrumb: [] },
    { path: configCorretora, label: 'Corretora', breadcrumb: [configuracoes] },
    { path: configUsuarios, label: 'Usuários', breadcrumb: [configuracoes] },
    { path: configSeguradoras, label: 'Seguradoras', breadcrumb: [configuracoes] },
    { path: configRamos, label: 'Ramos', breadcrumb: [configuracoes] },
    { path: configCoberturas, label: 'Coberturas', breadcrumb: [configuracoes] },
    { path: configPreferencias, label: 'Preferências da Corretora', breadcrumb: [configuracoes] },
    { path: corretorDigital, label: 'Painel do Corretor Digital', breadcrumb: [configuracoes] },
    { path: cotacoes, label: 'Cotações', breadcrumb: [] },
    { path: enviarCalculo, label: 'Enviar Para Cálculo', breadcrumb: [cotacoes, resultados, formulario] },
    { path: faturasNFe, label: 'Faturas e NF-e', breadcrumb: [] },
    { path: formulario, label: 'Formulário', breadcrumb: [cotacoes, resultados] },
    { path: formularioNovo, label: 'Formulário', breadcrumb: [cotacoes] },
    { path: orcamento, label: 'Orçamento', breadcrumb: [cotacoes, resultados] },
    { path: resultados, label: 'Resultados', breadcrumb: [cotacoes] },
    { path: resultadosAdmin, label: 'Resultados', breadcrumb: [cotacoes] },
    { path: simuladorDeComissoes, label: 'Simulador De Comissões', breadcrumb: [cotacoes, resultados] },
    { path: contratacao, label: 'Contratação', breadcrumb: [configuracoes] },
];